import script from "./ScrollTop.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrollTop.vue?vue&type=script&setup=true&lang=js"

import "./ScrollTop.vue?vue&type=style&index=0&id=e7feb46c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3689317901/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-prod-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7feb46c"]])

export default __exports__